var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2857 8H17.7143C14.5571 8 12.0286 10.3867 12.0286 13.3333L12.001 54.4999C12.0005 55.2182 12.7259 55.7096 13.3928 55.4429L31.6231 48.1508C31.865 48.054 32.135 48.054 32.3769 48.1508L50.6082 55.4433C51.2748 55.7099 52 55.219 52 54.501V13.3333C52 10.3867 49.4429 8 46.2857 8ZM46.2857 46.4926C46.2857 47.2129 45.5564 47.7039 44.8891 47.433L32.3818 42.355C32.137 42.2556 31.863 42.2556 31.6182 42.355L19.1109 47.433C18.4436 47.7039 17.7143 47.2129 17.7143 46.4926V14.3482C17.7143 13.7877 18.1687 13.3333 18.7292 13.3333H45.2708C45.8313 13.3333 46.2857 13.7877 46.2857 14.3482V46.4926Z",
    fill: "#8A96A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark_icon.1d4ba9a61997cb93b1dbce1c77f75c7f.svg";
export { ForwardRef as ReactComponent };